import { Outlet, useLocation } from 'react-router-dom'
import { AuthModalProvider, useAuthModal } from '../../contexts/AuthModalContext'
import { useAuth } from '../../hooks/useAuth'
import AuthModal from '../auth/AuthModal'
import Footer from './Footer'
import Navbar from './Navbar'

function AppLayoutContent() {
  const { isAuthenticated, loading } = useAuth()
  const location = useLocation()
  const { isOpen, view, closeAuthModal, setIsPaused } = useAuthModal()

  // Transparent navbar on home page for non-authenticated users
  const isLandingPage = location.pathname === '/' && !isAuthenticated && !loading

  // Check if we're on an authenticated route (sidebar layout)
  const isAuthenticatedRoute =
    ['/home', '/edit', '/account'].includes(location.pathname) ||
    location.pathname.startsWith('/blog') ||
    location.pathname.startsWith('/pages')

  const handleAuthSuccess = () => {
    closeAuthModal()
  }

  return (
    <div className="min-h-screen flex flex-col">
      {/* Hide navbar on authenticated routes (sidebar layout has its own navigation) */}
      {!isAuthenticatedRoute && <Navbar transparent={isLandingPage} />}
      <main className="flex-1">
        <Outlet />
      </main>
      {/* Hide footer on authenticated routes (sidebar layout) */}
      {!isAuthenticatedRoute && <Footer />}
      <AuthModal
        isOpen={isOpen}
        onClose={closeAuthModal}
        onSuccess={handleAuthSuccess}
        initialView={view}
        onPauseSlideshow={setIsPaused}
      />
    </div>
  )
}

export default function AppLayout() {
  return (
    <AuthModalProvider>
      <AppLayoutContent />
    </AuthModalProvider>
  )
}
